import React, {Component} from "react";
import shopify_logo from '../../images/shopify_glyph.png';
import shopify_logo_off from '../../images/shopify_glyph_off.png';
import shopify_logo_colorfully from '../../images/shopify_glyph_colorfully.png';

export class ShopifyLogo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isHovered: false
        };
    }

    getRenderVeryColoredVersion() {
        if(this.props.renderVeryColoredVersion)
            return this.props.renderVeryColoredVersion;
        return false;
    }

    getIsColoredOnHover() {
        if(this.props.isColoredOnHover)
            return this.props.isColoredOnHover;
        return false;
    }

    handleMouseEnter = () => {
        this.setState({ isHovered: true });
    }

    handleMouseLeave = () => {
        this.setState({ isHovered: false });
    }

    getHeight() {
        if(this.props.height)
            return this.props.height;
        return 30;
    }

    getWidth() {
        if(this.props.width)
            return this.props.width;
        return 30;
    }

    getHSpace() {
        if(this.props.hspace !== undefined)
            return this.props.hspace;
        return 10;
    }

    getVSpace() {
        if(this.props.vspace !== undefined)
            return this.props.vspace;
        return 10;
    }

    getImage() {
        if(this.getRenderVeryColoredVersion())
            return shopify_logo_colorfully;
        return !this.getIsColoredOnHover() || this.state.isHovered ? shopify_logo : shopify_logo_off;
    }

    render() {
        return <img alt="Shopify" style={this.props.styles} src={this.getImage()} height={this.getHeight()} width={this.getWidth()} hspace={this.getHSpace()} vspace={this.getVSpace()}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
        />
    }
}
